(() => {
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.threshold = Number.parseInt(this.dataset.stickyThreshold, 10) || 0;
      this.host = this.closest('[id^="shopify-section-"]');
      this.onScroll = this.updateSticky.bind(this);
      this.onResize = this.updateSticky.bind(this);
      this.onKeydown = this.handleNavigationKeydown.bind(this);
      this.onFocusout = this.handleNavigationFocusout.bind(this);
      this.onPointerover = this.reopenNavigation.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('orientationchange', this.onResize, { passive: true });
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusout);
      this.addEventListener('pointerover', this.onPointerover);
      this.updateSticky();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('orientationchange', this.onResize);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('focusout', this.onFocusout);
      this.removeEventListener('pointerover', this.onPointerover);
      this.host?.classList.remove('header-host--sticky');
    }

    handleNavigationKeydown(event) {
      const item = event.target.closest('.header-menu__item--has-children');
      if (!item) return;
      if (event.key === 'Escape') { event.preventDefault(); item.classList.add('is-escape-closed'); item.querySelector(':scope > a')?.focus(); }
      if (event.key === 'Enter' || event.key === ' ') item.classList.remove('is-escape-closed');
    }

    handleNavigationFocusout(event) { const item = event.target.closest('.header-menu__item--has-children'); if (item && !item.contains(event.relatedTarget)) item.classList.remove('is-escape-closed'); }
    reopenNavigation(event) { event.target.closest('.header-menu__item--has-children')?.classList.remove('is-escape-closed'); }

    updateSticky() {
      const isSticky = window.scrollY > this.threshold;
      this.classList.toggle('is-sticky', isSticky);
      this.classList.toggle('is-scrolled', window.scrollY > 0);
      const headerHeight = this.getBoundingClientRect().height;
      if (isSticky && headerHeight) this.host?.style.setProperty('--header-reserved-height', `${headerHeight}px`);
      this.host?.classList.toggle('header-host--sticky', isSticky && !this.classList.contains('header--transparent'));
    }
  }

  if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);
})();
